import React from 'react';


export class InTotalBar extends React.Component<{render_children:any}>{
    render(){
        return null;
    }
}